import React from 'react'
import BaseDataCheck from './ProgressChecks/BaseDataCheck'
import AttributesCheck from './ProgressChecks/AttributesCheck'
import VariousCheck from './ProgressChecks/VariousCheck'
import SupplyChainCheck from './ProgressChecks/SupplyChainCheck'
import OfficeAvailabilityCheck from './ProgressChecks/OfficeAvailabilityCheck'

import styled from 'styled-components'
import { useArticleDataState } from '../../../../stores/Configuration/ArticleDataProvider'

const StyledList = styled.ul`
  list-style: none;
  margin: 5px 0 0 0;
  padding: 0;
  font-size: 18px;

  li {
    padding: 10px 0;
  }
`

const Progress = () => {
    const { articleBaseObj, selectedOfficeAvailabilities } = useArticleDataState()
    return (
        <StyledList>
            <li>
                <BaseDataCheck baseData={articleBaseObj} />
            </li>
            <li>
                <AttributesCheck baseData={articleBaseObj} />
            </li>
            <li>
                <VariousCheck baseData={articleBaseObj} />
            </li>
            <li>
                <SupplyChainCheck baseData={articleBaseObj} />
            </li>
            <li>
                <OfficeAvailabilityCheck selectedOffices={selectedOfficeAvailabilities} />
            </li>
        </StyledList>
    )
}

export default Progress
